import React, { useRef, useEffect, useState } from 'react';
import MainStyle                    from "components/UI/main.module.scss";
import {GetSeferData}               from "SeferPetach/GetData";
import {useLoader}                          from "components/Covers/loadingCover";
import { validateEmail, 
         getImgSrc, 
         DefaultLoadingLogo,
         DavidCopperfield,
         Heimdall,
         GetLabel,
         GetAppLang,
         SetLastFeature }                   from "Utilities/utils";
export const GamePlayer = () => {
    return (
        <div style={{ width: '100%', height: '90vh' }}>
            <iframe
                src="https://pacman.js.org/"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                title="Pac-Man"
            />
        </div>
    );
};

export const Credits = () => {
  const [ credData, setCredData   ] = useState(null);
  const audioRef                    = useRef(null);

    const handleInteraction = () => {
        const audio = audioRef.current;
        if (audio) {
            audio.muted = false;
            audio.play().catch((err) => {
            console.warn('Autoplay failed:', err);
            });
        }
        window.removeEventListener('click', handleInteraction);
    };
    async function getData() {
        var payload = await GetSeferData("credits", {});
        return (payload);
    }
    useEffect(() => {
        const fetchData = async () => {
            let data = await getData();
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    setCredData(data);
                }
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (credData) {
            const audio = audioRef.current;
            const handleCanPlay = () => {
                window.addEventListener('click', handleInteraction);
            };
            audio?.addEventListener('canplaythrough', handleCanPlay);
            return () => audio?.removeEventListener('canplaythrough', handleCanPlay);
        }
    }, [credData]);
  
  return (
    <div style={{
        backgroundColor: '#000000ff', 
        color: '#eeff00ff', 
        height: '100%',
        overflow: 'hidden',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        display: 'flex',
        position: 'relative',        
    }}
    >
        {credData && (
            <React.Fragment>
                <audio ref={audioRef} src={`${window.location.origin}/media/media_song_01.mp3`} type="audio/mp3" autoPlay loop hidden muted/>
                <div className={MainStyle.star_wars_crawl}>
                    <div className={MainStyle.crawl_text}> 
                        <p className={MainStyle.text_center}>A long time ago in a galaxy far,<br/>far away...</p>
                        <br/>
                        <h1 className={MainStyle.text_center}>SURVEY SYSTEMS</h1>
                        <p className={MainStyle.mb_3}>EPISÓDIO III</p>
                        <p className={MainStyle.mb_3}>O EQUILÍBRIO DO CÓDIGO</p>
                        <p>
                            A galáxia corporativa mergulhava em caos.
                        </p>
                        <p>
                            Um sistema essencial para a sobrevivência da aliança tecnológica estava há muito em atraso. 
                        </p>
                        <p>
                            Tentativas falharam. 
                        </p>
                        <p>
                            A esperança vacilava...
                        </p>
                        <p>
                            Durante seis ciclos galácticos, dois analistas lutaram bravamente contra um código instável, integrações falhas e arquiteturas perdidas no tempo. 
                        </p>
                        <p>
                            Mas o sistema permaneceu incompleto... enfraquecido... sem rumo...sem esperança...
                        </p>
                        <p>
                            Quando tudo parecia perdido, das sombras surgiu um novo desafiante:
                        </p>
                        <p>
                            Julio Milani, antigo Jedi deposto do conselho e condenado a uma vida de miséria e sofrimento pelo membro do senado intergaláctico.
                        </p>
                        <p>
                            Forjado no lado sombrio do conhecimento técnico, Julio não lutava com promessas...mas com resultados. 
                        </p>
                        <p>
                            Com mãos firmes e mente implacável com o conhecimento da força, ele assumiu sozinho o controle de um sistema abandonado e condenado...
                        </p>
                        <p>
                            Durante 6 meses, enfrentou as forças obscuras do legado esquecido, bugs traiçoeiros e desafios que poucos ousariam encarar.
                        </p>
                        <p>
                            Sua abordagem não era gentil, mas era eficaz.
                        </p>
                        <p>
                            Julio não era herói... nem vilão.
                        </p>
                        <p>
                            Era o equilíbrio da força...
                        </p>
                        <p>
                            Agora, após uma jornada solitária, conheceu alguns aliados. 
                        </p>
                        <p>
                            Luis Oliveira das luas de Janeiror e Allyson Ribeiro do cículo de asteróides de Pauloo.
                        </p>
                        <p>
                            E bravos caçadores de recompensa de Suporttoine como Eric 3 espadas, Thawan mestre dos chicotes RJ45 entre outros bravos guerreiros de renome.
                        </p>
                        <p>
                            Após muitas lutas alucinantes com sabres o sistema está finalizado, estável e completo.
                        </p>
                        <p>
                            Pronto para trazer ordem à galáxia corporativa.
                        </p>                    
                        <p>
                            O ciclo se completou.
                        </p>
                        <p>
                            A força voltou a fluir.
                        </p>
                        <p>
                            A ordem foi restaurada.
                        </p>
                        <p>
                            E uma nova era de esperança começa...
                        </p>
                        <p>
                            Dedico esse sistema a todos os colaboradores do ISE Business School.
                        </p>
                        <p>
                            E também a todos os colaboradores que foram aposentados no ano de 2025.
                        </p>
                        {
                            Array.from({ length: 30 }, (_, i) => (
                                <br/>
                            ))
                        }
                        <p>
                            E a Hashem, minha esposa e filha que me apoiaram nessa jornada.
                        </p>
                        <p>
                            Escutaram minhas reclamações e me apoiaram com muito amor e carinho durante essa jornada de desenvolvimento solitário.
                        </p>
                        <p>
                            Pater noster, qui es in caelis: sanctificetur nomen tuum; adveniat regnum tuum; fiat voluntas tua, sicut in caelo et in terra. Panem nostrum quotidianum da nobis hodie, et dimitte nobis debita nostra, sicut et nos dimittimus debitoribus nostris; et ne nos inducas in tentationem; sed libera nos a malo. Amen.
                        </p>
                    </div>
                </div>
            </React.Fragment>
        )}
    </div>
  );

};

export const GetHelp = () => {
    const [ data, setData   ] = useState(null);
    const { showLoader, hideLoader }                            = useLoader();  

    async function getData() {
        var payload = await GetSeferData("help", {});
        return (payload);
    }
    useEffect(() => {
        const fetchData = async () => {
            showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(null, 0)});
            let data = await getData();
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content.help_data;
                    setData(data);
                    hideLoader();
                }
                else {
                    hideLoader();
                }
            }
            else {
                hideLoader();
            }
        };
        fetchData();
    }, []);

    return (
        <React.Fragment>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.text_body, MainStyle.mx_5, MainStyle.py_5].join(" ")}>
                        <div dangerouslySetInnerHTML={{ __html: data }} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}